<div class="add-user-group-main">
  <div class="d-flex justify-content-between align-items-center">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="pointer-cursor"
      (click)="navigateBack()"
    />
    <div>
      <p class="build-user-group mt-2 text-center">
        <app-with-tooltip [showHelpCursor]="true">{{
          'GROUPS' | translate
        }}</app-with-tooltip>
      </p>
    </div>

    <div class="col-1">
      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>
  </div>
  <div class="mt-4 row justify-content-center">
    <div *ngIf="stepper === 1" class="col-8">
      <h1 class="text-center heading1">
        {{ 'USER_GROUP' | translate }}
      </h1>
    </div>

    <div class="col-10">
      <h1 *ngIf="isEditMode" class="text-center heading1">
        {{ 'EDIT_GROUPS' | translate }}
      </h1>
      <h1 *ngIf="!isEditMode" class="text-center heading1">
        {{ 'ADD_GROUP' | translate }}
      </h1>
      <p class="sub-heading pb-15 pt-15">
        {{ 'CREATE_A_NAME_AND_ADD_DESCRIPTION' | translate }}
      </p>
    </div>
  </div>

  <div
    class="w-100 h-100 d-flex flex-column justify-content-center align-items-start"
  ></div>
  <div class="group-listing pl-1">
    <form
      [formGroup]="formGroup"
      id="ngForm"
      #userGroupForm="ngForm"
      (keyup.enter)="addUserGroup()"
    >
      <div class="form-group rounded-top form-container">
        <div class="scroll-container pr-2">
          <mat-form-field appearance="fill" class="w-100 mb-2">
            <mat-label>{{ 'GROUP_NAME_ASTERISK' | translate }}</mat-label>
            <input
              id="userGroup"
              matInput
              minlength="3"
              [placeholder]="'GROUP_NAME' | translate"
              formControlName="name"
            />
            <mat-error *ngIf="formGroup?.controls?.name?.errors?.whitespace">{{
              'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate
            }}</mat-error>
            <mat-error *ngIf="formGroup?.controls?.name?.errors?.required">{{
              'YOU_MUST_ENTER_GROUP_NAME' | translate
            }}</mat-error>
            <mat-error *ngIf="formGroup?.controls?.name?.errors?.minlength">
              {{
                commonService.stringInterPolation(
                  ("MINIMUM_OF_CHARACTERS" | translate),
                  "3"
                )
              }}
            </mat-error>
            <mat-error *ngIf="formGroup?.controls?.name?.errors?.maxlength">
              {{
                commonService.stringInterPolation(
                  ("MAXIMUM_OF_CHARACTERS" | translate),
                  "50"
                )
              }}
            </mat-error>
            <mat-error
              *ngIf="
                formGroup?.controls?.name?.errors?.entityName &&
                !formGroup?.controls?.name?.errors?.required &&
                !formGroup?.controls?.name?.errors?.whitespace &&
                !formGroup?.controls?.name?.errors?.minlength &&
                !formGroup?.controls?.name?.errors?.maxLength
              "
              >{{ 'YOU_MUST_ENTER_VALID_GROUP_NAME' | translate }}</mat-error
            >
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-100 mb-2">
            <mat-label>{{ 'GROUP_DESCRIPTION_ASTERISK' | translate }}</mat-label>
            <textarea
              matInput
              [placeholder]="'GROUP_DESCRIPTION' | translate"
              formControlName="description"
              class="description-box-size"
            >
            </textarea>

            <mat-error>
              <span
                *ngIf="formGroup?.controls?.description?.errors?.whitespace"
                >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}</span
              >
              <span
                *ngIf="formGroup?.controls?.description?.errors?.required"
                >{{ 'YOU_MUST_ENTER_GROUP_DESCRIPTION' | translate }}</span
              >
              <span
                *ngIf="formGroup?.controls?.description?.errors?.minlength"
                >{{ 'YOU_MUST_ENTER_MIN_FIVE_CHAR' | translate }}</span
              >

              <span *ngIf="formGroup?.controls?.description?.errors?.maxlength">
                {{
                  commonService.stringInterPolation(
                    ("MAXIMUM_OF_CHARACTERS" | translate),
                    "255"
                  )
                }}
              </span>
              <span
                *ngIf="
                  formGroup?.controls?.description?.errors
                    ?.alphaNumSpecialChar &&
                  !formGroup?.controls?.description?.errors?.required &&
                  !formGroup?.controls?.description?.errors?.whitespace &&
                  !formGroup?.controls?.description?.errors?.minlength &&
                  !formGroup?.controls?.description?.errors?.maxlength
                "
                >{{ 'YOU_MUST_ENTER_VALID_GROUP_DESCRIPTION' | translate }}</span
              >
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="row d-flex flex-row justify-content-center align-items-center">
    <button
      *ngIf="isEditMode"
      (click)="onRemoveGroup()"
      class="d-flex flex-row justify-content-center align-items-center d-none remove-btn"
      type="button"
      [controlDisabled]="[PageName.Building, CONSTANTS.DELETE]"
      [disabled]="userGroupForm?.invalid || isDefault"
    >
      <img src="assets/svg/ico-close-circle-outline.svg" />
      <p class="remove-group ml-2 pt-2">
        {{ 'REMOVE_GROUP' | translate }}
      </p>
    </button>
  </div>
  <div class="row pl-1">
    <button
      form="ngForm"
      [disabled]="userGroupForm?.invalid"
      class="btn btn-danger px-3 w-100 continue-btn"
      type="button"
      (click)="addUserGroup()"
    >
      {{ 'CONTINUE' | translate }}
    </button>
  </div>
</div>
